import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _efecf5be = () => interopDefault(import('..\\pages\\about\\index.vue' /* webpackChunkName: "pages/about/index" */))
const _3fff880c = () => interopDefault(import('..\\pages\\agenda\\index.vue' /* webpackChunkName: "pages/agenda/index" */))
const _17c41ea0 = () => interopDefault(import('..\\pages\\apply\\index.vue' /* webpackChunkName: "pages/apply/index" */))
const _cfa3dca4 = () => interopDefault(import('..\\pages\\contact\\index.vue' /* webpackChunkName: "pages/contact/index" */))
const _8052ef62 = () => interopDefault(import('..\\pages\\essayContest\\index.vue' /* webpackChunkName: "pages/essayContest/index" */))
const _5c0a34f0 = () => interopDefault(import('..\\pages\\firm\\index.vue' /* webpackChunkName: "pages/firm/index" */))
const _65e4a414 = () => interopDefault(import('..\\pages\\guest\\index.vue' /* webpackChunkName: "pages/guest/index" */))
const _14b676a6 = () => interopDefault(import('..\\pages\\interview\\index.vue' /* webpackChunkName: "pages/interview/index" */))
const _73a04575 = () => interopDefault(import('..\\pages\\links\\index.vue' /* webpackChunkName: "pages/links/index" */))
const _699e521a = () => interopDefault(import('..\\pages\\live\\index.vue' /* webpackChunkName: "pages/live/index" */))
const _1fcfdc5a = () => interopDefault(import('..\\pages\\news\\index.vue' /* webpackChunkName: "pages/news/index" */))
const _1dbaf1ea = () => interopDefault(import('..\\pages\\password\\index.vue' /* webpackChunkName: "pages/password/index" */))
const _102c3d74 = () => interopDefault(import('..\\pages\\privacy\\index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _7b470c85 = () => interopDefault(import('..\\pages\\profile\\index.vue' /* webpackChunkName: "pages/profile/index" */))
const _303018de = () => interopDefault(import('..\\pages\\search\\index.vue' /* webpackChunkName: "pages/search/index" */))
const _23ed83a2 = () => interopDefault(import('..\\pages\\videoDetail\\index.vue' /* webpackChunkName: "pages/videoDetail/index" */))
const _066a0116 = () => interopDefault(import('..\\pages\\videoList\\index.vue' /* webpackChunkName: "pages/videoList/index" */))
const _6dc0b350 = () => interopDefault(import('..\\pages\\apply\\journeyForm\\index.vue' /* webpackChunkName: "pages/apply/journeyForm/index" */))
const _2e65daab = () => interopDefault(import('..\\pages\\apply\\person\\index.vue' /* webpackChunkName: "pages/apply/person/index" */))
const _6f060e55 = () => interopDefault(import('..\\pages\\interview\\_id.vue' /* webpackChunkName: "pages/interview/_id" */))
const _5409bdc6 = () => interopDefault(import('..\\pages\\links\\_id.vue' /* webpackChunkName: "pages/links/_id" */))
const _6c166cfb = () => interopDefault(import('..\\pages\\news\\_id.vue' /* webpackChunkName: "pages/news/_id" */))
const _6f7a8f06 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _03bc55e1 = () => interopDefault(import('..\\pages\\_lang\\index.vue' /* webpackChunkName: "pages/_lang/index" */))
const _42033c34 = () => interopDefault(import('..\\pages\\_lang\\about\\index.vue' /* webpackChunkName: "pages/_lang/about/index" */))
const _67a6f7d5 = () => interopDefault(import('..\\pages\\_lang\\agenda\\index.vue' /* webpackChunkName: "pages/_lang/agenda/index" */))
const _6eb8fb65 = () => interopDefault(import('..\\pages\\_lang\\apply\\index.vue' /* webpackChunkName: "pages/_lang/apply/index" */))
const _055ed133 = () => interopDefault(import('..\\pages\\_lang\\contact\\index.vue' /* webpackChunkName: "pages/_lang/contact/index" */))
const _3d8c982c = () => interopDefault(import('..\\pages\\_lang\\essayContest\\index.vue' /* webpackChunkName: "pages/_lang/essayContest/index" */))
const _777647ba = () => interopDefault(import('..\\pages\\_lang\\firm\\index.vue' /* webpackChunkName: "pages/_lang/firm/index" */))
const _24028abb = () => interopDefault(import('..\\pages\\_lang\\guest\\index.vue' /* webpackChunkName: "pages/_lang/guest/index" */))
const _4cb8921c = () => interopDefault(import('..\\pages\\_lang\\interview\\index.vue' /* webpackChunkName: "pages/_lang/interview/index" */))
const _6ad5bb8c = () => interopDefault(import('..\\pages\\_lang\\links\\index.vue' /* webpackChunkName: "pages/_lang/links/index" */))
const _5be848b5 = () => interopDefault(import('..\\pages\\_lang\\live\\index.vue' /* webpackChunkName: "pages/_lang/live/index" */))
const _3b3bef24 = () => interopDefault(import('..\\pages\\_lang\\news\\index.vue' /* webpackChunkName: "pages/_lang/news/index" */))
const _2a09b826 = () => interopDefault(import('..\\pages\\_lang\\password\\index.vue' /* webpackChunkName: "pages/_lang/password/index" */))
const _651aa0cb = () => interopDefault(import('..\\pages\\_lang\\privacy\\index.vue' /* webpackChunkName: "pages/_lang/privacy/index" */))
const _2f1067ec = () => interopDefault(import('..\\pages\\_lang\\profile\\index.vue' /* webpackChunkName: "pages/_lang/profile/index" */))
const _9052568e = () => interopDefault(import('..\\pages\\_lang\\search\\index.vue' /* webpackChunkName: "pages/_lang/search/index" */))
const _03f8f8a7 = () => interopDefault(import('..\\pages\\_lang\\videoDetail\\index.vue' /* webpackChunkName: "pages/_lang/videoDetail/index" */))
const _3e6c1c8c = () => interopDefault(import('..\\pages\\_lang\\videoList\\index.vue' /* webpackChunkName: "pages/_lang/videoList/index" */))
const _6c3d7eab = () => interopDefault(import('..\\pages\\_lang\\apply\\journeyForm\\index.vue' /* webpackChunkName: "pages/_lang/apply/journeyForm/index" */))
const _39682270 = () => interopDefault(import('..\\pages\\_lang\\apply\\person\\index.vue' /* webpackChunkName: "pages/_lang/apply/person/index" */))
const _462413dc = () => interopDefault(import('..\\pages\\_lang\\apply\\person\\paramsBuilder.js' /* webpackChunkName: "pages/_lang/apply/person/paramsBuilder" */))
const _49613c84 = () => interopDefault(import('..\\pages\\_lang\\apply\\person\\components\\health\\index.vue' /* webpackChunkName: "pages/_lang/apply/person/components/health/index" */))
const _4792644c = () => interopDefault(import('..\\pages\\_lang\\interview\\_id.vue' /* webpackChunkName: "pages/_lang/interview/_id" */))
const _179a6b22 = () => interopDefault(import('..\\pages\\_lang\\links\\_id.vue' /* webpackChunkName: "pages/_lang/links/_id" */))
const _2bd96354 = () => interopDefault(import('..\\pages\\_lang\\news\\_id.vue' /* webpackChunkName: "pages/_lang/news/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _efecf5be,
    name: "about"
  }, {
    path: "/agenda",
    component: _3fff880c,
    name: "agenda"
  }, {
    path: "/apply",
    component: _17c41ea0,
    name: "apply"
  }, {
    path: "/contact",
    component: _cfa3dca4,
    name: "contact"
  }, {
    path: "/essayContest",
    component: _8052ef62,
    name: "essayContest"
  }, {
    path: "/firm",
    component: _5c0a34f0,
    name: "firm"
  }, {
    path: "/guest",
    component: _65e4a414,
    name: "guest"
  }, {
    path: "/interview",
    component: _14b676a6,
    name: "interview"
  }, {
    path: "/links",
    component: _73a04575,
    name: "links"
  }, {
    path: "/live",
    component: _699e521a,
    name: "live"
  }, {
    path: "/news",
    component: _1fcfdc5a,
    name: "news"
  }, {
    path: "/password",
    component: _1dbaf1ea,
    name: "password"
  }, {
    path: "/privacy",
    component: _102c3d74,
    name: "privacy"
  }, {
    path: "/profile",
    component: _7b470c85,
    name: "profile"
  }, {
    path: "/search",
    component: _303018de,
    name: "search"
  }, {
    path: "/videoDetail",
    component: _23ed83a2,
    name: "videoDetail"
  }, {
    path: "/videoList",
    component: _066a0116,
    name: "videoList"
  }, {
    path: "/apply/journeyForm",
    component: _6dc0b350,
    name: "apply-journeyForm"
  }, {
    path: "/apply/person",
    component: _2e65daab,
    name: "apply-person"
  }, {
    path: "/interview/:id",
    component: _6f060e55,
    name: "interview-id"
  }, {
    path: "/links/:id",
    component: _5409bdc6,
    name: "links-id"
  }, {
    path: "/news/:id",
    component: _6c166cfb,
    name: "news-id"
  }, {
    path: "/",
    component: _6f7a8f06,
    name: "index"
  }, {
    path: "/:lang",
    component: _03bc55e1,
    name: "lang"
  }, {
    path: "/:lang/about",
    component: _42033c34,
    name: "lang-about"
  }, {
    path: "/:lang/agenda",
    component: _67a6f7d5,
    name: "lang-agenda"
  }, {
    path: "/:lang/apply",
    component: _6eb8fb65,
    name: "lang-apply"
  }, {
    path: "/:lang/contact",
    component: _055ed133,
    name: "lang-contact"
  }, {
    path: "/:lang/essayContest",
    component: _3d8c982c,
    name: "lang-essayContest"
  }, {
    path: "/:lang/firm",
    component: _777647ba,
    name: "lang-firm"
  }, {
    path: "/:lang/guest",
    component: _24028abb,
    name: "lang-guest"
  }, {
    path: "/:lang/interview",
    component: _4cb8921c,
    name: "lang-interview"
  }, {
    path: "/:lang/links",
    component: _6ad5bb8c,
    name: "lang-links"
  }, {
    path: "/:lang/live",
    component: _5be848b5,
    name: "lang-live"
  }, {
    path: "/:lang/news",
    component: _3b3bef24,
    name: "lang-news"
  }, {
    path: "/:lang/password",
    component: _2a09b826,
    name: "lang-password"
  }, {
    path: "/:lang/privacy",
    component: _651aa0cb,
    name: "lang-privacy"
  }, {
    path: "/:lang/profile",
    component: _2f1067ec,
    name: "lang-profile"
  }, {
    path: "/:lang/search",
    component: _9052568e,
    name: "lang-search"
  }, {
    path: "/:lang/videoDetail",
    component: _03f8f8a7,
    name: "lang-videoDetail"
  }, {
    path: "/:lang/videoList",
    component: _3e6c1c8c,
    name: "lang-videoList"
  }, {
    path: "/:lang/apply/journeyForm",
    component: _6c3d7eab,
    name: "lang-apply-journeyForm"
  }, {
    path: "/:lang/apply/person",
    component: _39682270,
    name: "lang-apply-person"
  }, {
    path: "/:lang/apply/person/paramsBuilder",
    component: _462413dc,
    name: "lang-apply-person-paramsBuilder"
  }, {
    path: "/:lang/apply/person/components/health",
    component: _49613c84,
    name: "lang-apply-person-components-health"
  }, {
    path: "/:lang/interview/:id",
    component: _4792644c,
    name: "lang-interview-id"
  }, {
    path: "/:lang/links/:id",
    component: _179a6b22,
    name: "lang-links-id"
  }, {
    path: "/:lang/news/:id",
    component: _2bd96354,
    name: "lang-news-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
